import {Component, Input} from '@angular/core';
import {ControlContainer, FormGroupDirective} from '@angular/forms';

@Component({
    selector: 'app-post-text-editor',
    templateUrl: './post-text-editor.component.html',
    styleUrls: ['./post-text-editor.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class PostTextEditorComponent {
	@Input()
	public className: string;

	@Input()
	public controlName: string;
}
